import { TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { cloneDeep } from "lodash";
import { observer } from "mobx-react-lite";
import { IProductProperties } from "mobx-stores/_models/products/product";
import { useStores } from "mobx-stores/_root-store";
import { useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { DetailIconButton } from "share-components/mui-wrap/button/action-button";
import { XTablePagination } from "share-components/mui-wrap/table/x-table-pagination";
export const ProductTable = observer(() => {
  const {
    inProgress,
    productManagement: {
      getProducts,
      pagination,
      products,
      setProp,
      searchConditionAsNaturalLanguage,
    },
  } = useStores();
  const navigate = useNavigate();

  useEffect(() => {
    getProducts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onPageChanged = useCallback(
    async (_: any, page: number) => {
      pagination.setProp("pageIndex", page - 1);
      await getProducts();
    },
    [getProducts, pagination],
  );

  const goDetailHandler = useCallback(
    (product: IProductProperties) => {
      navigate(`${product.id}`);
      setProp("productDetail", cloneDeep(product));
    },
    [navigate, setProp],
  );

  return (
    <XTablePagination
      paginationProps={{
        count: pagination.totalPages,
        page: pagination.pageNumber,
        onChange: onPageChanged,
        disabled: inProgress,
      }}
      searchConditionAsNaturalLanguage={searchConditionAsNaturalLanguage}
    >
      <TableHead>
        <TableRow>
          <TableCell>STT</TableCell>
          <TableCell>Tên giao dịch</TableCell>
          <TableCell>Tên hàng</TableCell>
          <TableCell>Mã hàng</TableCell>
          <TableCell>Mã vạch</TableCell>
          <TableCell>DVT</TableCell>
          <TableCell>Yêu cầu khách hàng</TableCell>
          <TableCell>Ghi chú</TableCell>
          <TableCell></TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {products.map((x, i) => (
          <TableRow data-id={x.id} key={x.id} hover>
            <TableCell>{x.orderNumber || ""}</TableCell>
            <TableCell>{x.customer?.dealingName || ""}</TableCell>
            <TableCell>{x.name}</TableCell>
            <TableCell>{x.code}</TableCell>
            <TableCell>{x.barcode}</TableCell>
            <TableCell>{x.unitOfCalculation}</TableCell>
            <TableCell>{x.approval?.customerRequest || ""}</TableCell>
            <TableCell>{x.process?.note || ""}</TableCell>
            <TableCell width={"20px"}>
              <DetailIconButton
                onClick={() => goDetailHandler(x)}
              ></DetailIconButton>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </XTablePagination>
  );
});
